import React from "react";
import PropTypes from "prop-types";
import { Row, Col, Select, Input, Spin, message } from "antd";
import { StageService } from "services/index";
import { List } from "immutable";

class AssignModalContent extends React.Component {
    state = {
        stages: [],
        users: [],
        remarks: null,
        disableForm: true
    };
    componentDidMount() {
        StageService.getStages(
            this.props.stageId,
            this.props.type,
            this.props.caseId
        ).then(({ data }) => {
            const stages = new List(data);
            this.setState(
                {
                    stages,
                    stage: stages.first().id,
                    users: stages.first().user_list,
                    disableForm: false
                },
                () =>
                    this.props.onChange({
                        userId: this.state.users[0] && this.state.users[0].id,
                        remarks: null
                    })
            );
        }).catch(() => {
            this.setState({
                disableForm: false
            }, () => {
                message.error("Internet Connectivity Issue");
            });
        });
    }

    onUserSelect = userId => {
        this.props.onChange({
            userId,
            remarks: this.state.remarks
        });
    };
    onRemarksEdit = event => {
        this.props.onChange({
            userId: this.state.userId,
            remarks: event.target.value
        });
    };
    render() {
        if (this.state.disableForm) {
            return (
                <div className={"text-align-center"}>
                    <Spin />
                </div>
            );
        }
        return (
            <React.Fragment>
                <Row>
                    <Col span={24}>
                        <Select
                            placeholder={"Select a user"}
                            showSearch
                            style={{ width: "100%" }}
                            label={"User"}
                            onSelect={this.onUserSelect}
                            filterOption={(input, option) =>
                                option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                        >
                            {this.state.users.map(_ => (
                                <Select.Option key={_.id} value={_.id}>
                                    {_.full_name}
                                </Select.Option>
                            ))}
                        </Select>
                    </Col>
                    {this.props.isStageAdmin ? (
                        <Col span={24}>
                            <Input.TextArea
                                onChange={this.onRemarksEdit}
                                autosize={{ minRows: 2, maxRows: 3 }}
                            />
                        </Col>
                    ) : null}
                </Row>
            </React.Fragment>
        );
    }
}

AssignModalContent.propTypes = {
    onChange: PropTypes.func,
    caseId: PropTypes.string,
    stageId: PropTypes.number,
    stage: PropTypes.string,
    type: PropTypes.string,
    isStageAdmin: PropTypes.bool
};

export default AssignModalContent;
